import axios from "axios";
import { useApiKeyInterceptor, useAuthInterceptor, useLanguageInterceptor, useOrgUnitInterceptor } from "#/api";

const useAxios = () => {
	const domain = import.meta?.env?.MODE !== "https" ? import.meta.env.VITE_API_URL : "";
	const baseURL = `${domain}/api/`;

	//GET
	const axiosInstanceGet = axios.create({ baseURL });
	const axiosInstanceGetApiKey = axios.create({ baseURL });
	const axiosInstanceAuthenticationGet = axios.create({ baseURL });

	//POST
	const axiosInstancePost = axios.create({ baseURL });
	const axiosInstanceAuthenticationPost = axios.create({ baseURL });
	const axiosInstancePostApiKey = axios.create({ baseURL });
	const axiosInstanceAuthenticationPostApiKey = axios.create({ baseURL });

	// Auth
	useAuthInterceptor(axiosInstanceAuthenticationGet);
	useAuthInterceptor(axiosInstanceAuthenticationPost);
	useAuthInterceptor(axiosInstanceAuthenticationPostApiKey);

	//xAPIkey
	useApiKeyInterceptor(axiosInstancePostApiKey);
	useApiKeyInterceptor(axiosInstanceGetApiKey);
	useApiKeyInterceptor(axiosInstanceAuthenticationPostApiKey);

	// Language
	useLanguageInterceptor(axios);
	useLanguageInterceptor(axiosInstanceAuthenticationGet);
	useLanguageInterceptor(axiosInstanceAuthenticationPost);
	useLanguageInterceptor(axiosInstanceAuthenticationPostApiKey);
	useLanguageInterceptor(axiosInstancePost);
	useLanguageInterceptor(axiosInstanceGet);
	useLanguageInterceptor(axiosInstanceGetApiKey);
	useLanguageInterceptor(axiosInstancePostApiKey);

	// Org Unit
	useOrgUnitInterceptor(axios);
	useOrgUnitInterceptor(axiosInstanceAuthenticationGet);
	useOrgUnitInterceptor(axiosInstanceAuthenticationPost);
	useOrgUnitInterceptor(axiosInstanceAuthenticationPostApiKey);
	useOrgUnitInterceptor(axiosInstancePost);
	useOrgUnitInterceptor(axiosInstanceGet);
	useOrgUnitInterceptor(axiosInstanceGetApiKey);
	useOrgUnitInterceptor(axiosInstancePostApiKey);

	return {
		axiosInstanceAuthenticationGet,
		axiosInstanceAuthenticationPost,
		axiosInstanceAuthenticationPostApiKey,
		axiosInstancePost,
		axiosInstanceGet,
		axiosInstanceGetApiKey,
		axiosInstancePostApiKey,
	};
};

export default useAxios;
